import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import * as adapters from '../adapters/shipping-address';

type LatLngRes = { lat: string; lng: string };

/**
 * Hook: useGetMapLatLngFromShortLink
 *
 * Wraps the `getMapLatLngFromShortLink` adapter with react-query.
 * - Query key: ['shippingAddress', 'latlng', link]
 * - Enabled only when `link` is provided (non-empty string).
 *
 * Example:
 * const { data, isLoading, error } = useGetMapLatLngFromShortLink(shortLink);
 */
export const useGetMapLatLngFromShortLink = (
  link?: string,
  options?: Omit<UseQueryOptions<AxiosResponse<LatLngRes>, Error>, 'queryKey'>,
) => {
  return useQuery<AxiosResponse<LatLngRes>, Error>({
    queryKey: ['shippingAddress', 'latlng', link],
    queryFn: async () => {
      if (!link) throw new Error('link is required');
      return await adapters.getMapLatLngFromShortLink(link);
    },
    enabled: Boolean(link),
    ...options,
  });
};

export default useGetMapLatLngFromShortLink;
